module.exports = __webpack_public_path__ + "img/iphone15proMax.7cf7910e.png";